"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyBid = exports.removeBid = exports.bookmarkBid = exports.fetchBids = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bid/list");
const Actions = require("../../actions/bid/list");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function fetchBids(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => {
        let url = `${baseUrl}api/bid/briefcase/${action.payload.id}`;
        if ('status' in action.payload) {
            url = `${baseUrl}api/bid/${action.payload.id}/letter`;
        }
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return t
                .interface({
                bids: t.array(sok_types_1.Bid.iBidList),
                total: t.number
            })
                .decode(xhr.response)
                .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error))), (cases) => (0, rxjs_1.of)(Actions.fetchSuccess(cases)));
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.fetchBids = fetchBids;
function bookmarkBid(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.BOOKMARK_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: { status: action.payload.status },
        url: `${baseUrl}api/briefcase/${action.payload.briefcase.id}/bid/${action.payload.bid.id}/bookmark`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return sok_types_1.Bid.iBid
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.bookmarkFailed((0, errorHandling_1.parseValidationError)(error), action.payload.bid)), (cases) => (0, rxjs_1.of)(Actions.bookmarkSuccess(cases)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.bookmarkFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), action.payload.bid))))));
}
exports.bookmarkBid = bookmarkBid;
function removeBid(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        url: `${baseUrl}api/bid/${action.payload.bid.id}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const bid = store.value.bid.current.bid;
        const briefcase = store.value.briefcase.current.briefcase;
        const acts = [
            Actions.removeSuccess(action.payload.bid.id)
        ];
        if (bid) {
            acts.push(Actions.fetchRequest(bid));
        }
        else {
            briefcase && acts.push(Actions.fetchRequest(briefcase));
        }
        return (0, rxjs_1.of)(...acts);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.removeFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.removeBid = removeBid;
function copyBid(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.COPY_REQUEST), (0, operators_1.mergeMap)((action) => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            url: `${baseUrl}api/briefcase/${action.payload.briefcase.id}/bid/${action.payload.bid.id}/copy`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            if (xhr.status === 200) {
                const acts = [
                    Actions.copySuccess(),
                    Actions.fetchRequest(action.payload.briefcase)
                ];
                return (0, rxjs_1.of)(...acts);
            }
            else {
                return (0, rxjs_1.of)(Actions.copyFailed((0, errorHandling_1.parseAjaxErrorResponse)(xhr.response)));
            }
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.copyFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.copyBid = copyBid;
//# sourceMappingURL=list.js.map